<div class="palette" role="dialog" aria-label="Workflow palette" (keydown.escape)="closed.emit()">
  <div class="palette__head">
    <span class="palette__title">Workflows</span>
    <span class="palette__count">{{ workflows.length }}</span>
    <button type="button" class="palette__close" aria-label="Close palette" (click)="closed.emit()">✕</button>
  </div>

  <div class="palette__grid">
    <button
      type="button"
      class="palette__tile"
      *ngFor="let workflow of workflows; trackBy: trackWorkflow"
      [attr.aria-label]="workflow.name + ' — ' + workflow.description"
      (pointerdown)="onPressStart(workflow)"
      (pointerup)="onPressEnd(workflow)"
      (pointerleave)="onPressCancel()"
      (pointercancel)="onPressCancel()"
      (keydown.enter)="runRequested.emit(workflow.id)"
    >
      <span class="palette__glyph" aria-hidden="true" [style.color]="accentFor(workflow)">{{ workflow.glyph }}</span>
      <span class="palette__name">{{ workflow.name }}</span>
      <span class="palette__test" *ngIf="workflow.testMode" aria-label="Test workflow" title="Test workflow — runs safely on sample data">
        <span class="palette__test-icon" aria-hidden="true">🧪</span>TEST
      </span>
    </button>
  </div>

  <p class="palette__empty" *ngIf="!workflows.length">Nothing matches “{{ query }}”.</p>

  <button type="button" class="palette__define" (click)="defineRequested.emit()">
    Define new — records your next exchange
  </button>
</div>
